import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AiFindingsForAccessionNumberQueryVariables = Types.Exact<{
  accessionNumber: Types.Scalars['String'];
}>;


export type AiFindingsForAccessionNumberQuery = { readonly __typename?: 'Query', readonly aiFindingsForAccessionNumber: ReadonlyArray<{ readonly __typename?: 'AiFinding', readonly id: string, readonly sourceSystem?: string | null, readonly resolutionPath: string, readonly receivedAt: string, readonly payload: unknown }> };


export const AiFindingsForAccessionNumberDocument = gql`
    query AiFindingsForAccessionNumber($accessionNumber: String!) {
  aiFindingsForAccessionNumber(accessionNumber: $accessionNumber) {
    id
    sourceSystem
    resolutionPath
    receivedAt
    payload
  }
}
    `;

/**
 * __useAiFindingsForAccessionNumberQuery__
 *
 * To run a query within a React component, call `useAiFindingsForAccessionNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiFindingsForAccessionNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiFindingsForAccessionNumberQuery({
 *   variables: {
 *      accessionNumber: // value for 'accessionNumber'
 *   },
 * });
 */
export function useAiFindingsForAccessionNumberQuery(baseOptions: Apollo.QueryHookOptions<AiFindingsForAccessionNumberQuery, AiFindingsForAccessionNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiFindingsForAccessionNumberQuery, AiFindingsForAccessionNumberQueryVariables>(AiFindingsForAccessionNumberDocument, options);
      }
export function useAiFindingsForAccessionNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiFindingsForAccessionNumberQuery, AiFindingsForAccessionNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiFindingsForAccessionNumberQuery, AiFindingsForAccessionNumberQueryVariables>(AiFindingsForAccessionNumberDocument, options);
        }
export type AiFindingsForAccessionNumberQueryHookResult = ReturnType<typeof useAiFindingsForAccessionNumberQuery>;
export type AiFindingsForAccessionNumberLazyQueryHookResult = ReturnType<typeof useAiFindingsForAccessionNumberLazyQuery>;
export type AiFindingsForAccessionNumberQueryResult = Apollo.QueryResult<AiFindingsForAccessionNumberQuery, AiFindingsForAccessionNumberQueryVariables>;